import { Stack, Typography } from "@mui/material";

import './style.css';


export const EstimateData = ({ data }) => {

    const { contact, telContact, addressWork, status, iva, characteristics, concept, date, dateCall, measure, size, price, firstDate, lastDate, id } = !!data && data[0];

    return (
        <Stack mt='1rem' className="card" spacing={1} alignItems='center'>
            <Stack flexDirection='row' gap={2}>
                <Typography mb='1rem' variant="h5" color='primary' > Presupuesto </Typography>
                <Typography variant="subtitle1" mt='0.2rem' className="red"> ({status})</Typography>
            </Stack>
            <Stack flexDirection='row' flexWrap='wrap' width='90%' justifyContent='space-around'>
                <Stack alignItems='center' justifyContent='space-around' width='50%' spacing={1}>
                    <Typography variant="subtitle2"> <b> Nº de presupuesto: </b>   {id}</Typography>
                    <Typography variant="subtitle2"> <b> Persona de contacto: </b>   {contact}</Typography>
                    <Typography variant="subtitle2"> <b> Teléfono de contacto: </b>   {telContact}</Typography>
                    <Typography variant="subtitle2"> <b> Características: </b>   {characteristics}</Typography>
                    <Typography variant="subtitle2"> <b> Dirección de la obra: </b>   {addressWork}</Typography>
                    <Typography variant="subtitle2"> <b> Concepto: </b>   {concept}</Typography>
                </Stack>
                <Stack alignItems='center' justifyContent='space-around' width='50%' spacing={1}>
                    <Typography variant="subtitle2"> <b> Fecha presupuesto: </b>   {date}</Typography>
                    <Typography variant="subtitle2"> <b> Fecha de inicio: </b>   {firstDate}</Typography>
                    <Typography variant="subtitle2"> <b> Fecha de fin: </b>   {lastDate}</Typography>
                    <Stack flexDirection='row' gap={1}>
                        <Typography variant="subtitle2"> <b> Tamaño: </b> {size + measure}</Typography>
                        <Typography variant="subtitle2"> <b> Precio por {measure}: </b>   {price}</Typography>
                    </Stack>
                    <Typography variant="subtitle2"> <b> IVA: </b> {iva}</Typography>
                </Stack>
            </Stack>
            <Typography variant="subtitle2" color='red'> <b> Llamar el día: </b>   {dateCall}</Typography>
        </Stack >
    )
}